import React from 'react';
import clsx from 'clsx';
import {getDateForm} from '../../../../../@casino/lib/getDate';
import {useStyles} from './helpers';

const BlockGeneral = ({formik}) => {
    const classes = useStyles();

    return (
        <>
            <label htmlFor="bonus_name" className={clsx(classes.wrapLabel, classes.nameBonusLabel)}>
                <span className={classes.helper}>Имя бонуса</span>
                <input 
                    type="text" 
                    name="bonus_name" 
                    id="bonus_name" 
                    className={classes.text} 
                    value={formik.values.bonus_name} 
                    onChange={(v) => formik.setFieldValue('bonus_name', v.target.value)}
                />
            </label>
            <label htmlFor="template">
                <span className={classes.helper}>Валюта расчета бонуса</span>
                <select 
                    id="template" 
                    name="template" 
                    className={classes.select}
                    value={formik.values.template} 
                    onChange={(v) => formik.setFieldValue('template', v.target.value)}
                >
                    <option value="RUB">₽</option>
                </select>
            </label>
            <div className={classes.wrapActiveBonus}>
                <label htmlFor="bonus_start" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                    <span className={classes.helper}>Начало активности бонуса</span>
                    <input 
                        type="datetime-local" 
                        name="bonus_start" 
                        id="bonus_start" 
                        className={classes.text}
                        value={getDateForm(formik.values.bonus_start)} 
                        onChange={(v) => formik.setFieldValue('bonus_start', new Date(v.target.value))}
                    />
                </label>
                <label htmlFor="bonus_end" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                    <span className={classes.helper}>Конец активности бонуса</span>
                    <input 
                        type="datetime-local" 
                        name="bonus_end" 
                        id="bonus_end" 
                        className={classes.text}
                        value={getDateForm(formik.values.bonus_end)} 
                        onChange={(v) => formik.setFieldValue('bonus_end', new Date(v.target.value).getTime())}
                    />
                </label>
                <label htmlFor="max_activation_time" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                    <span className={classes.helper}>Максимальное время для принятия решения</span>
                    <input 
                        type="text" 
                        name="max_activation_time" 
                        id="max_activation_time" 
                        className={classes.text}
                        value={formik.values.max_activation_time} 
                        onChange={(v) => formik.setFieldValue('max_activation_time', v.target.value)}
                    />
                </label>
            </div>
        </>
    )
}

export default BlockGeneral;